import { BaseModel } from '@Core';
import { GeoZones } from './GeoZones';

export interface CameraView extends ViewPTZ, BaseModel {
    CameraId: number;
    CameraViewName?: string;
    GeoZones?: GeoZones[];
    ViewType: CameraViewType;
    LastPhotoBlob?: string;
    Order?: number;
    PresetId?: number;
}

export interface ViewPTZ {
    PtzPanPos: string;
    PtzTiltPos: string;
    PtzZoomPos: string;
}

export interface ViewPreset extends ViewPTZ {
    GotoPointId: number;
    PresetName: string;
}

export interface PhotoSnapShotByPTZ {
    PTZ: ViewPTZ;
    Base64PhotoSnapShot: string;
}

export enum CameraViewType {
    ViewOverview,
    ViewDetail,
}

export interface GeoZoneViewInfo {
    ViewName: string;
    GracePeriod: number;
}
export interface PatrolTimeForecast {
    TimeForecast: number;
    GeoZoneViewInfo: GeoZoneViewInfo[];
}
